import { Close } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Box, Grid, IconButton, Paper } from '@mui/material';
import React from 'react';

export interface FormModalContainerProperties {
  children: any;
  onClose?: () => void;
  width?: number;
  dataCy?: string;
  title?: React.ReactNode;
}

export const FormModalContainer = ({
  children,
  onClose = () => {},
  width = 700,
  dataCy,
  title = null,
}: FormModalContainerProperties) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="flex-start"
      style={{ width: '100%', maxWidth: width }}
      data-cy={dataCy}
    >
      <Paper elevation={3} style={{ width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              minHeight: '44px',
              paddingTop: '8px',
            }}
          >
            {title ? (
              <Typography
                variant="h6"
                sx={{ textAlign: 'center', maxWidth: '80%', wordBreak: 'break-word', fontWeight: 600 }}
              >
                {title}
              </Typography>
            ) : null}
            <IconButton
              data-cy={`close-modal`}
              aria-label="Закрыть окно"
              component="span"
              size="small"
              sx={{ position: 'absolute', right: 8 }}
              onClick={() => {
                onClose();
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Box sx={{ width: '100%' }}>{children}</Box>
        </Box>
      </Paper>
    </Grid>
  );
};
